// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import TerceraInstrumentLookupTextBoxTemplate from '@front/templates/TerceraInstrumentLookupTextBoxTemplate.html';
import { ControlsTypes, PanelNames } from '../../UtilsClasses/FactoryConstants';
import { TerceraTextBox } from '../TerceraTextBox';
import { CustomerAccess } from '@shared/commons/CustomerAccess/CustomerAccess';
import { MainWindowManager } from '../../UtilsClasses/MainWindowManager';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
export class TerceraInstrumentLookupTextBox extends TerceraTextBox {
    constructor() {
        super(...arguments);
        this.symbolInfoAllowed = false;
    }
    getType() {
        return ControlsTypes.TerceraInstrumentLookupTextBox;
    }
    oninit() {
        super.oninit();
        this.observe('currentInstrument', this.onInstrumentChanged);
        this.onInsTypeImgMouseDown = this.onInsTypeImgMouseDown.bind(this);
        this.symbolInfoAllowed = CustomerAccess.panelAllowed(PanelNames.SymbolInfoPanel);
    }
    oncomplete() {
        super.oncomplete();
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
    }
    onteardown() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.onteardown();
    }
    onSubmitEvent(event) {
        if (event === null || event === void 0 ? void 0 : event.original) {
            event.original.preventDefault();
        }
    }
    localize() {
        void this.set('insTypeImgTT', Resources.getResource('TerceraInstrumentLookup.InstrTypeImg.tt'));
        this.updateDelayTooltip();
    }
    onInsTypeImgMouseDown() {
        let instrument = this.get('currentInstrument');
        if (isNullOrUndefined(instrument))
            return;
        void this.set('isSymbolInfoOpened', true);
        const onSymbolInfoCloseCallback = () => {
            void this.set('isSymbolInfoOpened', false);
        };
        if (instrument.InstrumentTradableID == null) {
            // when click on underlier in OptionMaster's instrument lookup
            instrument = instrument.ForwardBaseInstrument; // #122997
        }
        MainWindowManager.MainWindow.ShowSymbolInfo(instrument, this.get('selectedAccount'), onSymbolInfoCloseCallback);
    }
    onInstrumentChanged(instrument, lastInstrument) {
        if (instrument !== lastInstrument) {
            this.subscribeRiskSettingsUpdate(instrument, lastInstrument);
        }
        this.updateDelayTooltip();
        void this.set('showInsTypeImg', this.symbolInfoAllowed && (instrument === null || instrument === void 0 ? void 0 : instrument.isHide) == null);
        if (isNullOrUndefined(instrument)) {
            return;
        }
    }
    updateDelayTooltip() {
        const instrument = this.get('currentInstrument');
        if (isNullOrUndefined(instrument) || instrument.isHide) {
            return;
        }
        void this.set({
            hasDelay: instrument.HasDelay(),
            delayedTooltip: instrument.GetDelayedIconTooltip()
        });
    }
    subscribeRiskSettingsUpdate(instrument, lastInstrument) {
        if (!isNullOrUndefined(lastInstrument) && !lastInstrument.isHide) {
            lastInstrument.RiskSettingsUpdated.UnSubscribe(this.instrumentSettingsUpdate, this);
        }
        if (!isNullOrUndefined(instrument) && !instrument.IsEmpty && !instrument.isHide) {
            instrument.RiskSettingsUpdated.Subscribe(this.instrumentSettingsUpdate, this);
        }
    }
    instrumentSettingsUpdate() {
        const instrument = this.get('currentInstrument');
        if (isNullOrUndefined(instrument)) {
            return;
        }
        this.onInstrumentChanged(instrument, instrument); // for hasDelay/delayedTooltip update
    }
}
TerceraTextBox.extendWith(TerceraInstrumentLookupTextBox, {
    template: TerceraInstrumentLookupTextBoxTemplate,
    data: function () {
        return {
            currentInstrument: null,
            selectedAccount: null,
            showInsTypeImg: false,
            hasDelay: false, // #112155
            delayedTooltip: '',
            insTypeImgTT: ''
        };
    }
});
